import React, { useEffect, useState } from "react";
import TableCompo from "../Table/TableCompo";
import { useDispatch, useSelector } from "react-redux";
import { getBullionMarginsRequest } from "../../../redux/Bullion/BullionSlice";

const BullionMarginTable = () => {
  const dispatch = useDispatch();

  const {
    marginList = [],
    marginTotal = 0,
    loading = false,
  } = useSelector((state) => state.bullions || {});
  console.log("marginList", marginList);

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(
      getBullionMarginsRequest({
        page: page + 1,
        limit,
        search,
      }),
    );
  }, [page, limit, search]);

  const handleTableChange = (type, payload) => {
    if (type === "changePage") {
      setPage(payload.page);
    }

    if (type === "changeRowsPerPage") {
      setLimit(payload.rowsPerPage);
      setPage(0);
    }
    if (type === "search") {
      setSearch(payload.searchText || "");
      setPage(0);
    }
  };
  const formattedData = marginList.map((item, index) => ({
    ...item,
    _id: item._id + "_" + index,
  }));

  const columns = [
    { field: "metalName", headerName: "Metal" },
    {
      field: "purity",
      headerName: "Purity",
      render: (_, row) => `${row.karat}K - ${row.purity}`,
    },
    { field: "country", headerName: "country" },
    { field: "state", headerName: "State" },
    { field: "rateType", headerName: "Rate Type" },
    { field: "marginType", headerName: "Margin Type" },
    { field: "margin", headerName: "Margin" },
  ];

  return (
    <TableCompo
      columns={columns}
      data={formattedData}
      page={page}
      limit={limit}
      totalCount={marginTotal}
      onTableChange={handleTableChange}
      loading={loading}
    />
  );
};

export default BullionMarginTable;
